module.exports = __webpack_public_path__ + "img/рз_16.6a5cb36f.png";